export const QuestionnaireType = {
  CERVICAL: 'ShpCervicalCancerScreening',
  MAMMOGRAM: 'ShpMammogram',
  OSA: 'TRIAGE-OAS-DC-SHP_EN',
  PRE: 'SHP-Q004',
} as const;

export const RequestFormType = {
  Cancel: 'cancel',
  Change: 'change',
  ChangeOrCancel: 'changeorcancel',
  Make: 'make',
  FollowUp: 'followup',
} as const;
export type RequestFormTypeType = (typeof RequestFormType)[keyof typeof RequestFormType];

export const BookNextFormType = {
  Miss: 'BookMiss',
  Open: 'BookOpen',
} as const;

export const TCUMakeNewType = {
  Future: 'Future',
  Today: 'Today',
} as const;
export type TCUMakeNewTypeType = (typeof TCUMakeNewType)[keyof typeof TCUMakeNewType];

export const CervicalQuestionIds = {
  appointmentType: 'CCS-Q005',
  contactNumber: 'CCS-Q003',
  emailAddress: 'CCS-Q004',
  nric: 'CCS-Q001',
  patientName: 'CCS-Q002',
  ageCheckPapSmear: 'CCS-Q008',
  ageCheckHpvDna: 'CCS-Q009',
} as const;

export const VideoConsultProceedSteps = {
  CONTACT_DETAILS: 0,
  DELIVERY: 1,
  PAYMENT: 2,
  SUMMARY: 3,
} as const;
export type VideoConsultProceedStepsType = (typeof VideoConsultProceedSteps)[keyof typeof VideoConsultProceedSteps];

export const ServiceTypeName = {
  CervicalCancerScreening: 'Cervical Cancer Screening',
  DoctorConsultation: 'Doctor Consultation',
  HealthierSGConsult: 'Healthier@SG Consult',
  HealthPlanDiscussion: 'Health Plan Discussion',
  MammogramScreening: 'Mammogram Screening',
} as const;

export const ServiceTypeIds = {
  MammogramScreening: '113019',
  HASService: '1',
} as const;

export const MMG_OFFERING_ID = '32';

export const DentalApptDeposit = {
  ForfeitDays: 3,
} as const;

export const DentalApptDepositMessages = {
  DentalApptReschedule: 'Appointment.Message.Dental.RescheduleWithinForfeitDays',
  DentalApptCancel: 'Appointment.Message.Dental.CancelWithinForfeitDays',
  DentalApptBook: 'Appointment.Message.Dental.NewWithinForfeitDays',
} as const;

export type DentalApptDepositMessagesType = (typeof DentalApptDepositMessages)[keyof typeof DentalApptDepositMessages];

export const DoctorConsultDisclaimerMessages = {
  Nhgp: 'Appointment.DoctorConsultDisclaimer.NHGP',
  NhgpPreview: 'Appointment.DoctorConsultDisclaimer.NHGPPreview',
  Nup: 'Appointment.DoctorConsultDisclaimer.NUP',
  NupPreview: 'Appointment.DoctorConsultDisclaimer.NUPPreview',
  Shp: 'Appointment.DoctorConsultDisclaimer.SHP',
  ShpPreview: 'Appointment.DoctorConsultDisclaimer.SHPPreview',
};

export const DoctorConsultApptMessages = {
  SlotsAvailability: 'Appointment.DoctorConsult.SlotsAvailability',
  SlotStatus: 'Appointment.DoctorConsult.SlotStatus',
} as const;

export const DentalApptDepositSettings = {
  ForfeitDays: 'Appointment.DentalDeposit.ForfeitDays',
  ServiceTypes: 'Appointment.DentalServiceTypeId',
} as const;

export const DoctorConsultApptSettings = {
  AvailabilityFrom: 'Appointment.DoctorConsult.Availability.From',
  AvailabilityTo: 'Appointment.DoctorConsult.Availability.To',
} as const;

export interface OperatingDay {
  day: string;
  hours: OperatingHour[];
}
interface OperatingHour {
  registrationClose?: string;
  time: string;
}
